<template>
    <div class="container">
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
const AppContainer = defineComponent({});
export default AppContainer;
</script>
<style>
@media (min-width: 1600px) {
    .container {
        max-width: 1600px;
    }
}

@media (min-width: 1904px) {
    .container {
        max-width: 1785px;
    }
}
.container {
    margin: auto;
}
</style>
